import React from 'react'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import TextField from '@mui/material/TextField'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import AdapterDateFns from '@mui/lab/AdapterDateFns'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import DesktopDatePicker from '@mui/lab/DesktopDatePicker'
import koLocale from 'date-fns/locale/ko'

import { FORM_PANEL_SX, FORM_SUB_PANEL_SX } from '../../component/formSurfaceStyles'
import { APP_PUSH_WEEK_OPTIONS } from './appPushDraftUtils'
import { HOUR_OPTIONS, MINUTE_OPTIONS } from './pushReserveTime'

const reservePanelSx = {
    ...FORM_SUB_PANEL_SX,
}

function ReservePanelTitle({ children }) {
    return (
        <Typography variant="subtitle2" sx={{ fontWeight: 800 }}>
            {children}
        </Typography>
    )
}

export default function AppPushReserveFields({
    isReserve,
    reserveHour,
    reserveMinute,
    checked,
    saving,
    onReserveHourChange,
    onReserveMinuteChange,
    onWeekTypeChange,
    startTime,
    endTime,
    onStartTimeChange,
    onEndTimeChange,
}) {
    if (Number(isReserve) !== 1) {
        return null
    }

    return (
        <Grid item xs={12}>
            <Paper variant="outlined" sx={{ ...FORM_PANEL_SX, boxShadow: 'none' }}>
                <Box sx={{ mb: 1.5 }}>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700 }}>
                        예약 발송 설정
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                        예약 발송 시간, 요일, 기간을 구분해 설정합니다.
                    </Typography>
                </Box>
                <Box
                    sx={{
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', md: 'repeat(2, minmax(0, 1fr))' },
                        gap: 1.5,
                    }}
                >
                    <Paper variant="outlined" sx={reservePanelSx}>
                        <FormControl component="fieldset" fullWidth>
                            <ReservePanelTitle>발송 시간</ReservePanelTitle>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mt: 1 }}>
                                <FormControl size="small" sx={{ minWidth: 120 }}>
                                    <Select
                                        displayEmpty
                                        value={reserveHour ?? ''}
                                        onChange={onReserveHourChange}
                                        disabled={saving}
                                        renderValue={(selected) => selected !== '' ? selected : '시'}
                                    >
                                        <MenuItem value="">시</MenuItem>
                                        {HOUR_OPTIONS.map((hour) => (
                                            <MenuItem key={hour} value={hour}>{hour}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                                <Box>:</Box>
                                <FormControl size="small" sx={{ minWidth: 120 }}>
                                    <Select
                                        displayEmpty
                                        value={reserveMinute ?? ''}
                                        onChange={onReserveMinuteChange}
                                        disabled={saving}
                                        renderValue={(selected) => selected !== '' ? selected : '분'}
                                    >
                                        <MenuItem value="">분</MenuItem>
                                        {MINUTE_OPTIONS.map((minute) => (
                                            <MenuItem key={minute} value={minute}>{minute}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </FormControl>
                    </Paper>
                    <Paper variant="outlined" sx={reservePanelSx}>
                        <FormControl component="fieldset" fullWidth>
                            <ReservePanelTitle>발송 요일</ReservePanelTitle>
                            <FormGroup aria-label="position" row sx={{ mt: 0.5 }}>
                                {APP_PUSH_WEEK_OPTIONS.map((item) => (
                                    <FormControlLabel
                                        key={item.id}
                                        control={<Checkbox onChange={onWeekTypeChange} value={item.id} name="weekType" disabled={saving} />}
                                        checked={checked.includes(item.id)}
                                        label={item.name}
                                        disabled={saving}
                                    />
                                ))}
                            </FormGroup>
                        </FormControl>
                    </Paper>
                    <Paper variant="outlined" sx={{ ...reservePanelSx, gridColumn: { xs: 'auto', md: '1 / -1' } }}>
                        <ReservePanelTitle>발송 기간</ReservePanelTitle>
                        <Grid container spacing={1.5} sx={{ mt: 0.5 }}>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={koLocale}>
                                        <DesktopDatePicker
                                            label="시작일"
                                            inputFormat="yyyy-MM-dd"
                                            mask={"____-__-__"}
                                            value={startTime}
                                            onChange={onStartTimeChange}
                                            renderInput={(params) => <TextField {...params} size="small" disabled={saving} />}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <FormControl fullWidth>
                                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={koLocale}>
                                        <DesktopDatePicker
                                            label="종료일"
                                            inputFormat="yyyy-MM-dd"
                                            mask={"____-__-__"}
                                            value={endTime}
                                            onChange={onEndTimeChange}
                                            renderInput={(params) => <TextField {...params} size="small" disabled={saving} />}
                                        />
                                    </LocalizationProvider>
                                </FormControl>
                            </Grid>
                        </Grid>
                    </Paper>
                </Box>
            </Paper>
        </Grid>
    )
}
